<template>
  <div class="wrap">
    <div id="header_nav" class="header">
      <div class="logo border_box">
        <div class="logo_img">
          <img src>
        </div>
        <div class="logo_txt wid300">天津市教育系统网络安全和舆情管控应急指挥平台</div>
      </div>
      <div class="userinfo_box">
        <div class="user_box" style="border: none;">
          <div class="el-dropdown" style="width: 150px;">
            <div class="user_img">
              <img src="/ssologin/static/images/user_icon.png">
              <span class="user_name">{{userName}}</span>
            </div>
            <ul class="subset_nav">
              <div style="position:absolute;height: 30px;width: 100%;top:-30px;left:0;"></div>
              <li @click="gosetting('/Set/userinfo')">个人信息</li>
              <li @click="gosetting('/Set/groupManagement')" v-if="funList.length > 0">系统设置</li>
              <li @click="gosetting('/Set/systemLog')">日志审计</li>
              <li @click="gosetting('/exit')">退出</li>
              <div class="popper__arrow"></div>
            </ul>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div id="goBack" class="goback" @click='$router.push("/loginIndex")'>返回</div>

    <div class="center">
      <set-nav :hover="'organization'"></set-nav>

      <div class="set-infowary">
        <div class="tit">
          <a class="hover">组织机构管理</a>
        </div>
        <div class="group_management_wrap ">
          <!--左盒子-->
          <div class="group_tree_wrap">
            <div class="group_tree_box">
              <vue-ztree
                :list.sync="ztreeDataSource"
                :func="nodeClick"
                :is-open="false"
                :is-check="false"
                @addGroup="addGroup"
                @editGroup="editGroup"
                @delGroup="delGroup"
                @changeid="changeid"
              ></vue-ztree>
            </div>
          </div>
          <!--右边盒子-->
          <div class="set_meal_statistics">
            <h3 class="statistics_title">套餐统计</h3>

            <div class="statistics_list">
              <ul class="statistics_list_con clearfix last">
                <li>
                  <p class="bigger">人员数</p>
                  <p class="smaller">统计类型</p>
                </li>
                <li>
                  <p class="bigger" the-id="maxUser">{{checkSetMealUse.maxUser}}</p>
                  <p class="smaller">总数</p>
                </li>
                <li>
                  <p class="bigger" the-id="alreadyUser">{{checkSetMealUse.alreadyUser}}</p>
                  <p class="smaller">已用</p>
                </li>
                <li>
                  <p class="bigger" the-id="remaindUser">{{checkSetMealUse.maxUser -checkSetMealUse.alreadyUser}}</p>
                  <p class="smaller">剩余</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class></div>

        <!-- <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button> -->
        <!-- :before-close="handleClose" -->
        <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="360px" :show-close="false">
          <div class="group_sucess_tips">
            <!-- <p class="success_tips">提示</p> -->
            <p class="success_info">添加成功</p>
            <p class="success_info2">马上给新单位进行系统授权吧？</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">授 权</el-button>
          </span>
        </el-dialog>

        <!-- Form 添加组织 -->
        <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

        <el-dialog
          :model="form"
          :title="titleType"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          custom-class="add_group"
          @close="closeDialog"
          width="560px"
        >
          <el-form
            :model="form"
            ref="form"
            :rules="rules"
            :label-position="labelPosition"
            :label-width="formLabelWidth"
          >
            <el-form-item label="组织名称" prop="name">
              <el-input v-model="form.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="使用人数" prop="maxUser" v-if="form.pId != 0 ">
              <el-input
                v-model.number="form.maxUser"
                controls-position="right"
                @keyup ="handleChange" 
                :min="0"
                label="描述文字"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否授权监测">
				      <el-switch v-model="delivery"></el-switch>
            </el-form-item>-->
          </el-form>
          <!-- <div class="org_tips">备注：授权监测后会占用一个监测单位数，同时新增单位会有独立的监测舆情的能力</div> -->
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('form')">保 存</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>

        <!-- Form 系统授权 -->
        <!-- <el-button type="text" @click="dialogFormVisible2 = true">打开授权表单的 Dialog</el-button> -->

        <el-dialog
          :model="form2"
          title="系统授权"
          :visible.sync="dialogFormVisible2"
          :width="form2width"
          :close-on-click-modal="false"
          custom-class="authorize_group"
          @close="closeDialog"
        >
          <el-form
            :model="form2"
            ref="form2"
            :rules="rules"
            :label-position="labelPosition"
            :label-width="formLabelWidth"
          >
            <div class="authorize_company_box">
              <p>授权单位</p>
              <h3>技术部3组b组</h3>
            </div>
            <div class="authorize_company_content clearfix">
              <div class="authorize_left">
                <div class="authorize_title clearfix">
                  是否启用数据授权
                  <label>
                    <el-checkbox v-model="checkAll">全选</el-checkbox>
                  </label>
                </div>
                <el-tree
                  :data="data2"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  default-expand-all
                  :expand-on-click-node="false"
                  :props="defaultProps"
                ></el-tree>
              </div>
              <div class="authorize_right authorize_width">
                <div class="authorize_title">功能授权</div>
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item name="1">
                    <template slot="title">
                      一致性 Consistency
                      <el-checkbox
                        :indeterminate="authorizeItems.isIndeterminate"
                        v-model="authorizeItems.checkAll"
                        @change="handleCheckAllChange"
                      >全选</el-checkbox>
                    </template>

                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group
                      v-model="authorizeItems.checkedCities"
                      @change="handleCheckedCitiesChange"
                    >
                      <el-checkbox
                        v-for="city in authorizeItems.cities"
                        :label="city"
                        :key="city"
                      >{{city}}</el-checkbox>
                    </el-checkbox-group>
                  </el-collapse-item>
                  <el-collapse-item title="反馈 Feedback" name="2">
                    <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
                    <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
                  </el-collapse-item>
                  <el-collapse-item title="效率 Efficiency" name="3">
                    <div>简化流程：设计简洁直观的操作流程；</div>
                    <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
                    <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
                  </el-collapse-item>
                  <el-collapse-item title="可控 Controllability" name="4">
                    <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
                    <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('form2')">保 存</el-button>
            <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible3" width="30%">
          <span>您确定要删除这个组织吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible3 = false">取 消</el-button>
            <el-button type="primary" @click="handleClose3">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
// import yqzjHead from '../../components/header.vue'
// import yqzjFooter from '../../components/footer.vue'
import setNav from "./setNav.vue";
import vueZtree from "./vue-ztree.vue";
import * as loginAPI from "@/api/login.js";
// import VueCookies from 'vue-cookies'

import {
  getGroupTree,
  checkSetMealUse,
  addGroupInfo,
  editGroupInfo,
  delGroupInfo
} from "../../api/orgment.js";

const cityOptions = ["上海", "北京", "广州", "深圳"];

export default {
  data() {
    var validateOrgname = (rule, value, callback) => {
      var newVal = value.trim().replace(/\s/g, ""); //去掉首位空格，过滤掉中间的空格后，进行验证
      if (newVal.length == 0) {
        callback(new Error("不能为空"));
      } else if (newVal.length > 20) {
        callback(new Error("最多20个字符"));
      } else {
        callback();
      }
    };

    return {
      userName: this._util.getStorage("ssoUserInfo").name || "",
      funList: [],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogVisible3: false,
      titleType: "添加组织",
      labelPosition: "right",
      delivery: false,
      form: {
        name: "",
        pId: 0,
        orgLevel: 0,
        isDatanode: 0,
        maxUser: 0,
        msUserId: this._util.getStorage("ssoUserInfo").msUserId
      },
      formLabelWidth: "100px",

      // num1: 0,
      rules: {
        name: [{ validator: validateOrgname }]
      },
      form2: {},
      form2width: "840px",
      //tree
      checkAll: false,
      // 记录默认展开节点
      showKeyId:[],
      treeDataList:[],
      data2: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1"
                },
                {
                  id: 10,
                  label: "三级 1-1-2"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1"
            },
            {
              id: 6,
              label: "二级 2-2"
            }
          ]
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1"
            },
            {
              id: 8,
              label: "二级 3-2"
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      //折叠面板
      activeNames: ["1"],
      authorizeItems: {
        checkAll: false,
        checkedCities: ["上海", "北京"],
        cities: cityOptions,
        isIndeterminate: true
      },
      //查看组织树
      dataList: [],
      ztreeDataSource: [],
      parentNodeModel: [], //当前点击节点父亲对象
      nodeModel: null, // 当前点击节点对象
      //查看套餐
      checkSetMealUse: {
        maxDatanode: 0,
        alreadyDatanode: 0,
        remaindDatanode: 0,
        maxUser: 0,
        alreadyUser: 0,
        remaindUser: 0
      }
    };
  },
  components: {
    vueZtree,
    // yqzjHead,
    // yqzjFooter,
    setNav
  },
  methods: {
    gosetting(a) {
      if (a !== "/exit") {
        this.$router.push({
          path: a
        });
      } else {
        localStorage.clear();
        window.localStorage.clear();
        // window.location = window.expertConfig.newUrl+'exit';
        let data = {
          accountId: this.accountId
        };
        loginAPI.dologOut(data).then(res => {
          if (res.code == 0) {
            this.$router.push({
              path: "/"
            });
          }
        });
      }
    },
    getRoleFunList() {
      let data = {
        accountId: this._util.getStorage("ssoUserInfo").accountId
      };
      loginAPI.getRoleFunList(data).then(res => {
        if (res.code == 0) {
          this.funList = res.data.funList;
          this._util.setStorage("ssoNav", res.data.funList[0].funSonList);
        }
      });
    },
    handleClose() {},
    closeDialog() {
      //console.log(11);
      //this.$refs[formName].resetFields();//清除表单验证
    },
    handleChange(value) {
      console.log(111111)
    },
    submitForm(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          // alert('submit!');
          // if (that.delivery) {
          //   that.form.isDatanode = 1;
          // } else {
          //   that.form.isDatanode = 0;
          // }

          that.form.groupId = parseInt(
            this._util.getStorage("ssoUserInfo").generalGroupId
          );
          that.form.orgLevel = that.form.orgLevel + 1;

          console.log("------------that.form2------------");
          // console.log(that.form);
          if (this.titleType == "添加组织") {
            addGroupInfo(that.form)
              .then(function(res) {
                console.log("------------res------------");
                // console.log(res);
                if (res.code == 0) {
                  // 0 失败  1 成功
                  that.dialogFormVisible = false;
                  that.$message.success("保存成功！")
                  that.showKeyId.push(that.form.pId);
                  console.log(that.form)
                  let params = {
                    groupId: that._util.getStorage("ssoUserInfo")
                      .generalGroupId,
                    accountId: that._util.getStorage("ssoUserInfo").accountId
                  };
                  getGroupTree(params)
                    .then(function(res) {
                      res.data.forEach((item,ind) => {
                        if (that.showKeyId.indexOf(item.id) >= 0) {
                          res.data[ind].isFolder = true;
                        }
                      })
                      that.ztreeDataSource = that.traversezTreeData(res.data);
                      //_this.dataParameter.orgIds = _this.ztreeDataSource[0].id;
                      //_this.getOrgUserInfo();
                    })
                    .catch(err => {
                      console.log(err, "请求失败！");
                    });
                } else {
                  // 0 失败  1 成功
                  that.dialogFormVisible = false;
                  that.$message.error(res.msg);
                }
              })
              .catch(err => {
                console.log(err, "请求失败！");
              });
          } else {
            editGroupInfo(that.form)
              .then(function(res) {
                console.log("------------res------------");
                // console.log(res);
                if (res.code == 0) {
                  // 0 失败  1 成功
                  that.dialogFormVisible = false;
                  that.$message.success("保存成功！")
                  let params = {
                    groupId: that._util.getStorage("ssoUserInfo")
                      .generalGroupId,
                    accountId: that._util.getStorage("ssoUserInfo").accountId
                  };
                  getGroupTree(params)
                    .then(function(res) {
                      res.data.forEach((item,ind) => {
                        if (that.showKeyId.indexOf(item.id) >= 0) {
                          res.data[ind].isFolder = true;
                        }
                      })
                      that.ztreeDataSource = that.traversezTreeData(res.data);
                      //_this.dataParameter.orgIds = _this.ztreeDataSource[0].id;
                      //_this.getOrgUserInfo();
                    })
                    .catch(err => {
                      console.log(err, "请求失败！");
                    });
                } else {
                  // 0 失败  1 成功
                  that.dialogFormVisible = false;
                  that.$message.error("保存失败");
                }
              })
              .catch(err => {
                console.log(err, "请求失败！");
              });
          }

          // that.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCheckAllChange(val) {
      this.authorizeItems.checkedCities = val ? cityOptions : [];
      this.authorizeItems.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.authorizeItems.checkAll =
        checkedCount === this.authorizeItems.cities.length;
      this.authorizeItems.isIndeterminate =
        checkedCount > 0 && checkedCount < this.authorizeItems.cities.length;
    },
    // 点击节点
    nodeClick: function(m, parent, trees) {
      this.treeDeepCopy = trees;
      this.nodeModel = m; // 当前点击节点对象
      this.parentNodeModel = parent; //当前点击节点父亲对象
      // m.ico = true;
      console.log("========m==============");
      // console.log(m);
      // this.getMealUse(m.groupId)
      //console.log(parent);

      // 导航菜单
      // this.dataList=[]
      // this.findById(this.ztreeDataSource,m.parentId)
      // this.dataList= this.dataList.reverse();
      // this.dataList.push(m);
    },
    findById: function(data, parentId) {
      var vm = this;
      for (var i = 0; i < data.length; i++) {
        if (parentId == data[i].id) {
          // console.log(data[i]);
          vm.dataList.push(data[i]);
          vm.findById(vm.ztreeDataSource, data[i].parentId);
          return data[i];
        }
        if (data[i].hasOwnProperty("children")) {
          vm.findById(data[i].children, parentId);
        }
      }
    },
    addGroup: function(model) {
      console.log(
        "groupManagement--------------------------------------------"
      );
      // console.log(model);
      // console.log(model.name);
      this.titleType = "添加组织";
      this.dialogFormVisible = true;
      let id = model.id, //id作为新增元素的pId
        orgLevel = model.orgLevel, //组织层级
        isDatanode = model.isDatanode; //是否是数据节点   0否 1 是

      this.form.pId = id;
      this.form.orgLevel = orgLevel;
      this.form.isDatanode = isDatanode;

      this.form.name = "";
      this.form.maxUser = 0;
      console.log("-------this.form---------");
      // console.log(this.form);
    },

    editGroup: function(model) {
      console.log(
        "groupManagement--------------------------------------------"
      );
      // console.log(model);
      // console.log(model.name);
    
      let id = model.id, //id作为新增元素的pId
        orgLevel = model.orgLevel, //组织层级
        isDatanode = model.isDatanode, //是否是数据节点   0否 1 是
        name = model.name,
        maxUser = model.maxUser,
        groupId = model.groupId,
        msUserId = model.msUserId,
        pId = model.pId;

      this.form.pId = id;
      this.form.orgLevel = orgLevel;
      this.form.isDatanode = isDatanode;
      this.form.name = name;
      this.form.maxUser = maxUser;
      this.form.groupId = groupId;
      this.form.msUserId = msUserId;
      this.form.pId = pId;
      this.form.id = id;
      this.titleType = "编辑组织";
      this.dialogFormVisible = true;
      console.log("-------this.form---------");
      // console.log(this.form);
    },
    delGroup: function(model) {
      this.dialogVisible3 = true;
      this.form.groupId = model.groupId;
      this.form.id = model.id;
    },
    handleClose3() {
      let _this = this;
      let data = {
        groupId: this.form.groupId,
        id: this.form.id
      };
      delGroupInfo(data)
        .then(function(res) {
          if (res.code == 0) {
            _this.$message.success("删除成功！");
            _this.dialogVisible3 = false;
            let params = {
              groupId: _this._util.getStorage("ssoUserInfo").generalGroupId,
              accountId: _this._util.getStorage("ssoUserInfo").accountId
            };
            getGroupTree(params)
              .then(function(res) {
                res.data.forEach((item,ind) => {
                  if (_this.showKeyId.indexOf(item.id) >= 0) {
                    res.data[ind].isFolder = true;
                  }
                })
                _this.ztreeDataSource = _this.traversezTreeData(res.data);
                //_this.dataParameter.orgIds = _this.ztreeDataSource[0].id;
                //_this.getOrgUserInfo();
              })
              .catch(err => {
                console.log(err, "请求失败！");
              });
          } else {
            _this.$message.error(res.msg);
            _this.dialogVisible3 = false;
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    },
    changeid:function (m) {
      if (m.isFolder) {
        this.showKeyId.push(m.id);
      } else {
        let ind = this.showKeyId.indexOf(m.id);
        this.showKeyId.splice(ind,1);
      }
    },
    //简单树转换复杂树
    traversezTreeData (data) {
      var zTreeData = [];
      let flag = false // 记录是否有匹配上的选中的节点，防止前选中节点后删除该节点，树找不到默认选中节点
      for (let i in data) {
        let parentData = data[i];
        //console.log('--------parentData---------');
        //console.log(parentData);
        parentData.children = [];
        parentData.ico = true; //是否显示增删改查icon
        parentData.parentId = parentData.pId;
        for (let j in data) {
          if (parentData.id == data[j].pId) {
            parentData.open = true;
            parentData.children.push(data[j]);
          }
        }
        if(this.nodeModel && this.nodeModel.id && data[i].id == this.nodeModel.id){
          parentData.clickNode = true    
          flag = true
        }
      }
      if (!(this.nodeModel && this.nodeModel.id && flag)) {
        data[0].clickNode = true;
      }
      zTreeData[0] = data[0];
      // console.log(data[0]);
      return zTreeData;
    },
    getMealUse(groupid) {
      //查看套餐
      var _this = this;
      checkSetMealUse(groupid)
        .then(function(res) {
          console.log("=============查看套餐==============");
          // console.log(res);
          if (res.code == "0") {
            //监测单位数--总数
            _this.checkSetMealUse.maxDatanode = res.data.maxDatanode;
            //监测单位数--已用
            _this.checkSetMealUse.alreadyDatanode = res.data.alreadyDatanode;
            //监测单位数--剩余
            _this.checkSetMealUse.remaindDatanode =
              res.data.maxDatanode - res.data.alreadyDatanode;
            //人员数--总数
            _this.checkSetMealUse.maxUser = res.data.maxUser;
            //人员数--已用
            _this.checkSetMealUse.alreadyUser = res.data.alreadyUser;
            //人员数--剩余
            _this.checkSetMealUse.remaindUser =
              res.data.maxUser - res.data.result.data.alreadyUser;
          }
        })
        .catch(err => {
          console.log(err, "请求失败！");
        });
    }
  },
  mounted() {
    let _this = this;
    _this.getRoleFunList();
    //组织树数据获取
    let data = {
      groupId: this._util.getStorage("ssoUserInfo").generalGroupId,
      accountId: this._util.getStorage("ssoUserInfo").accountId
    };
    getGroupTree(data)
      .then(function(res) {
        res.data.forEach((item,ind) => {
          if (_this.showKeyId.indexOf(item.id) >= 0) {
            res.data[ind].isFolder = true;
          }
        })
        // console.log(_this.treeDataList)
        _this.ztreeDataSource = _this.traversezTreeData(res.data);
        //_this.dataParameter.orgIds = _this.ztreeDataSource[0].id;
        //_this.getOrgUserInfo();
      })
      .catch(err => {
        console.log(err, "请求失败！");
      });
    this.getMealUse(this._util.getStorage("ssoUserInfo").generalGroupId);
  },
  watch: {
    treeDataList:{
      handler (n,o) {
        console.log(n,o)
        this.treeDataList = n;
      },
      deep: true
    }
  }
};
</script>
<!--scoped-->
<style lang="less">
.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfix {
  overflow: auto;
  zoom: 1; /* For IE 6/7 (trigger hasLayout) */
}
.wrap {
  background-color: #f2f2f2;
  width: 100%;
}
.center {
  margin: 30px auto 30px;
  width: 94%;
  min-height: 500px;
  position: relative;
  overflow: hidden;
  padding-bottom: 30px;
}
.set-infowary {
  width: 81%;
  float: right;
}
.tit {
  width: 100%;
  //border-bottom: 1px solid #e5e5e5;
  border: 1px solid #e5e5e5;
  padding: 20px 0 0;
  font-size: 16px;
  font-family: "黑体";
  overflow: hidden;
  background: #fff;
  border-radius: 6px;
}
.tit a {
  padding-bottom: 20px;
  color: #4c4c4c;
  margin-left: 20px;
  float: left;
  padding-right: 5px;
  display: block;
}
.tit a.hover {
  border-bottom: 2px solid #38a9e1;
  color: #1f96d2;
}
.group_management_wrap {
  width: 100%;
  margin: 12px auto 0;
  padding-bottom: 20px;
  overflow: hidden;
}
.group_tree_wrap {
  width: 240px;
  float: left;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  background-color: #fff;
  margin-bottom: 20px;
  // max-height: 600px;
  // overflow: auto;
}
//左侧树样式
.group_tree_box {
  border-radius: 6px;
  background-color: #fff;
  overflow: auto;

  .ztree {
    * {
      font-size: 14px;
    }
    li {
      line-height: 40px !important;
      a {
        height: 40px;
        line-height: 40px;
        padding-top: 0px;
      }
    }
  }
}

//右侧套餐统计
.set_meal_statistics {
  overflow: hidden;
  margin-left: 252px;
  // padding-top: 10px;
  width: auto;
  float: none;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  background-color: #fff;

  .statistics_title {
    height: 48px;
    line-height: 48px;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    padding: 0 30px;
    border-bottom: 1px solid #e6e6e6;
  }

  .statistics_list {
    .statistics_list_con {
      padding: 23px 0;
      border-bottom: 1px solid #e6e6e6;

      li {
        float: left;
        border-right: 1px dashed #e6e6e6;
        height: 90px;
        line-height: 45px;
        text-align: center;
        box-sizing: border-box;
        -moz-box-sizing: border-box; /* Firefox */
        -webkit-box-sizing: border-box; /* Safari */

        .bigger {
          color: #333333;
          font-size: 18px;
          font-weight: bold;
        }

        .smaller {
          color: #999;
          font-size: 14px;
          font-weight: bold;
        }

        &:nth-child(1) {
          width: 34%;
        }

        &:nth-child(2) {
          width: 22%;
        }

        &:nth-child(3) {
          width: 22%;
        }

        &:nth-child(4) {
          width: 22%;
          border-right: none;
        }
      }

      &.last {
        border-bottom: none;
      }
    }
  }
}
//授权弹窗
.authorize_group .el-form {
  max-height: 440px;
  overflow: auto;
}
.authorize_company_box {
  padding: 30px 0;
  text-align: center;
}
.authorize_company_box p {
  color: #666;
  font-size: 16px;
}
.authorize_company_box h3 {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  margin-top: 12px;
}
.authorize_company_content {
  padding: 0 20px 30px;
}
.authorize_left {
  float: left;
  width: 240px;
}
.authorize_right {
}
.authorize_width {
  width: 498px;
  width: 510px;
  float: right;
}
.authorize_title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  //border-bottom: 1px solid #e5e5e5;
  border-bottom: 1px solid #ebeef5;
  line-height: 48px;

  label {
    color: #666;
    font-size: 14px;
    padding-right: 12px;
    float: right;

    input[type="checkbox"] {
      margin-left: 4px;
      vertical-align: text-bottom;
    }
  }
}
.authorize_right .authorize_title {
  border-bottom: none;
}
//添加组织
.org_tips {
  color: #ff3333;
  font-size: 12px;
  margin: 20px 0 0;
  background: #fff3f3;
  height: 32px;
  line-height: 32px;
  padding: 0 18px;
  border-radius: 6px;
}
/*提示信息*/
.group_sucess_tips {
  .success_tips {
    color: #666;
    font-size: 12px;
    text-align: center;
    margin-bottom: 18px;
  }
  .success_info {
    color: #333;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }
  .success_info2 {
    color: #333;
    font-size: 14px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}


</style>
<style scoped lang="less">
.goback {
    background: #0f2847;
    cursor: pointer;
    margin-left: 40px;
    width: 100px;
    height: 40px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    margin-top: 10px;
    border-radius: 10px;
}
.header {
  width: 100%;
  height: 64px;
  background-color: #0f2847;
  box-shadow: 0 2px 15px #e5e5e5;
  z-index: 888;
  min-width: 1100px;
  position: relative;
  .logo {
    width: 600px;
    float: left;
    height: 64px;
    padding: 8px 0;
    margin-left: 3%;
    overflow: hidden;
    font-size: 0;
    .wid300 {
      max-width: 100%;
      line-height: 48px;
    }
    .logo_txt {
      display: inline-block;
      font-size: 24px;
      color: #fff;
      vertical-align: middle;
      max-height: 48px;
      overflow: hidden;
    }
  }
  .userinfo_box {
    float: right;
    // margin-right: 5%;
  }
  .sys_setup {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: url(../../images/setting.png) no-repeat;
    background-size: 20px 20px;
    vertical-align: top;
    margin: -1px 0 0 10px;
    cursor: pointer;
  }
}
.userSetBox {
  position: relative;
  z-index: 1000;
}
.userinfo_box {
  float: right;
  // margin-right: 5%;
  // margin-top: 2%;
}
.userinfo_box .user_box {
  float: left;
  border-left: 1px solid #a5aabb;
  height: 18px;
  line-height: 18px;
  margin-top: 23px;
  margin-left: 12px;
  font-size: 0;
  position: relative;
}
.userinfo_box .user_box div.user_img {
  margin: 0 12px;
  cursor: pointer;
  display: flex;
}
.userinfo_box .user_box div.user_img img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: top;
  margin-top: 1px;
  border: 0px none;
}
.userinfo_box .user_box div.user_img span.user_name {
  font-size: 14px;
  color: #fff;
  white-space: nowrap;
}
.userinfo_box .user_box .subset_nav {
  position: absolute;
  top: 26px;
  left: -8px;
  padding: 10px 0;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 96px;
  display: none;
}
.userinfo_box .user_box .el-dropdown:hover .subset_nav {
  display: block;
}
.userinfo_box .user_box .subset_nav li {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: 0;
  width: auto;
  height: auto;
}
.userinfo_box .user_box .subset_nav li:hover {
  background-color: #ecf5ff;
}
.userinfo_box .user_box .subset_nav li:hover a {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a {
  font-size: 14px;
  font-family: "\5B8B\4F53";
  color: #606266;
}
.userinfo_box .user_box .subset_nav li a:hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a.hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav .popper__arrow,
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.userinfo_box .user_box .subset_nav .popper__arrow {
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  left: 50%;
  top: -6px;
  border-top-width: 0;
  border-bottom-color: #ebeef5;
  margin-left: -6px;
}
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  content: " ";
  border-width: 6px;
  border-bottom-color: #fff;
  border-top-width: 0;
  margin-left: -6px;
  top: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/Organization.vue